<template>
  <v-card tile>
    <v-dialog v-model="dialog" width="70%">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="primary" dark class="ma-2" @click="createUser()">
          {{ formTitle }}
        </v-btn>
      </template>
      <user-form
        v-if="newUser"
        :formTitle="formTitle"
        @save="handleSaveUser"
        @cancel="dialog = false"
        :user="newUser"
      ></user-form>
    </v-dialog>
    <v-card-title>
      Personnel {{ this.users.length }}
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Chercher" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="users"
      :loading="loading"
      no-data-text="'Aucun resultat trouvé'"
      :items-per-page="200"
      :search="search"
      :footer-props="{
        itemsPerPageText: 'Nombre de lignes',
        pageText: 'Lignes {0}-{1} de {2}',
      }"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{ item.name }}</td>
            <td>{{ item.email }}</td>
            <td>
              <v-chip
                class="mr-2"
                dark
                v-for="role in item.roles"
                :key="role.id"
                v-model="role.name"
                :color="getRoleColor(role.name)"
              >
                {{ translateRole(role.name) }}
              </v-chip>
            </td>
            <td>
              <v-btn text icon color="blue" @click="resendEmail(item)">
                <v-icon>mdi-email-sync</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn text icon color="red" @click="deleteItem(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import User from "@/models/User"
import UserForm from "@/components/users/UserForm.vue"

export default {
  components: {
    UserForm,
  },
  data() {
    return {
      formTitle: "Créer un compte",
      loading: true,
      search: "",
      headers: [
        { text: "Nom", value: "name" },
        { text: "Email", value: "email" },
        { text: "Role", value: "role" },
        { text: "Reinitialiser", value: "resend", sortable: false },
        { text: "Effacer", value: "delete", sortable: false },
      ],
      pagination: {},
      query: "",
      dialog: false,
      newUser: null,
    }
  },
  async mounted() {
    await User.get()
    this.loading = false
  },
  computed: {
    users() {
      return User.all()
    },
  },
  methods: {
    translateRole(role) {
      return User.translateRole(role)
    },
    getRoleColor(role) {
      return User.getRoleColor(role)
    },
    async handleSaveUser(newUser) {
      this.loading = true
      this.dialog = false
      await User.create(newUser)
        .then(() => (this.user = new User()))
        .finally(() => {
          this.dialog = false
          this.loading = false
        })
    },
    createUser() {
      this.newUser = new User()
      this.dialog = true
    },
    async deleteItem(user) {
      this.loading = true
      await User.deleteOneById(user.id)
      this.loading = false
    },
    async resendEmail(user) {
      this.loading = true
      await User.resendEmail(user.id)
      this.loading = false
    },
  },
}
</script>
<style scoped>
.clickable {
  cursor: pointer;
}
</style>
